import { NotificationDto } from './notification.dto';

export class DmNotificationsResponseDto {
  unreadNotifications: NotificationDto[];
  readNotifications: NotificationDto[];
}
